import { FC } from 'react'

import { Button } from '@trustycars/genie-ui/components'

import { header } from '$blocks/common/auth.css'
import ExtraIcon from '$icons/ExtraIcon'

import usePasskey from '$actions/useMFABlock/usePasskey'

import {
  title as titleStyle,
  description as descriptionStyle,
  icon,
  container,
  btn,
  iconLoading
} from './styles.css'
import { Icon } from '@trustycars/genie-ui/icons/Icon'

export type PasskeyAuthenticateBlockProps = ReturnType<typeof usePasskey>

export const PasskeyAuthenticateBlock: FC<PasskeyAuthenticateBlockProps> = ({
  authenticate,
  hasError,
  isSuccess,
  isAnyLoading
}) => {
  const idle = () => (
    <>
      <ExtraIcon name="key-round" className={icon} />

      <header className={header}>
        <h2 className={titleStyle}>Passkey</h2>

        <p className={descriptionStyle}>Authenticate using the button below</p>
      </header>

      <Button
        styleVariants={{ size: 'small', kind: 'success' }}
        onClick={authenticate}
        disabled={isAnyLoading}
        className={btn}
      >
        Use passkey
      </Button>
    </>
  )

  const success = () => (
    <>
      <Icon namespace="TickCircle" className={icon} />

      <header className={header}>
        <h2 className={titleStyle}>Success!</h2>

        <p className={descriptionStyle}>Your passkey has been verified.</p>
      </header>
    </>
  )

  const waiting = () => (
    <>
      <ExtraIcon name="pin-loader" className={iconLoading} />

      <header className={header}>
        <h2 className={titleStyle}>Waiting Passkey verification</h2>
      </header>
    </>
  )

  const denied = () => (
    <>
      <ExtraIcon name="circular-cross" className={icon} />

      <header className={header}>
        <h2 className={titleStyle}>Failed to authenticate</h2>

        <p className={descriptionStyle}>Want to request again?</p>
      </header>

      <Button
        styleVariants={{ size: 'small', kind: 'success' }}
        onClick={authenticate}
        disabled={isAnyLoading}
        className={btn}
      >
        Retry passkey
      </Button>
    </>
  )

  const isIdle = !hasError && !isSuccess

  return (
    <div
      className={container}
      style={{ cursor: isAnyLoading ? 'progress' : 'auto' }}
    >
      {isAnyLoading ? (
        waiting()
      ) : (
        <>
          {isIdle && idle()}

          {hasError && denied()}

          {isSuccess && success()}
        </>
      )}
    </div>
  )
}

export default PasskeyAuthenticateBlock
